<div class="overlay-background">
  <div class="bg-white rounded-lg p-4 text-center">
    <span class="h4">{{ title }}</span>
    <hr />
    <div
      style="
        display: flex;
        flex-direction: column;
        gap: 2px;
        margin-bottom: 1rem;
      "
    >
      <ng-container *ngIf="!isArray(message); else messageArray">
        <p style="margin-bottom: 0">{{ message }}</p>
      </ng-container>
      <ng-template #messageArray>
        <p *ngFor="let msg of message" style="margin-bottom: 0">{{ msg }}</p>
      </ng-template>
    </div>
    <div class="d-flex" style="gap: 8px">
      <button
        class="btn btn-success"
        style="width: 100%"
        (click)="confirm.emit()"
      >
        YES
      </button>
      <button
        class="btn btn-danger"
        style="width: 100%"
        (click)="cancel.emit()"
      >
        NO
      </button>
    </div>
  </div>
</div>
